import { useState } from "react";
import axios from "axios";
import { ChevronRight, Lock, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API });

export function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState(""); const [done, setDone] = useState(false); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot", { email: email.trim() }); setDone(true); }
    finally { setBusy(false); }
  };
  return <div className="modal-backdrop"><div className="modal" data-testid="forgot-modal">
    <button className="icon-btn close" onClick={onClose} data-testid="close-forgot">×</button>
    <p className="eyebrow">PASSWORD RECOVERY</p>
    <h3>Forgot your password?</h3>
    <p className="muted">We'll email a reset link to the address on file. The link stays active for 30 minutes.</p>
    {done ? <div className="info-box" data-testid="forgot-success">If that email exists in our system, a reset link is on its way. Check your inbox and spam.</div>
     : <form onSubmit={submit}>
        <label>Email<input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@school.in" data-testid="forgot-email-input" /></label>
        <button className="primary-btn wide" disabled={busy} data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"} <ChevronRight size={17} /></button>
      </form>}
  </div></div>;
}

export default function ResetPage({ token, onDone }) {
  const [password, setPassword] = useState(""); const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false); const [err, setErr] = useState(""); const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (password.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (password !== confirm) { setErr("Passwords don't match"); return; }
    setBusy(true);
    try { await api.post("/auth/reset", { token, password }); setOk(true); }
    catch (x) { setErr(x.response?.data?.detail || "Reset link is invalid or expired. Please request a new one."); }
    finally { setBusy(false); }
  };
  return <main className="login-shell reset-shell"><section className="login-panel full-width"><div className="login-panel-inner">
    <div className="mobile-logo"><ShieldCheck size={20} /> FeeMitra</div>
    <p className="eyebrow">PASSWORD RESET</p>
    <h2><Lock size={20} /> Choose a new password</h2>
    {ok ? <>
      <div className="info-box" data-testid="reset-success">Your password has been updated. You can now sign in with your new password.</div>
      <button className="primary-btn wide" onClick={onDone} data-testid="reset-go-login">Go to sign in <ChevronRight size={17} /></button>
    </> : <form onSubmit={submit}>
      <label>New password<input type="password" required minLength={8} value={password} onChange={e => setPassword(e.target.value)} data-testid="reset-password-input" /></label>
      <label>Confirm password<input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} data-testid="reset-confirm-input" /></label>
      {err && <div className="error-box" data-testid="reset-error">{err}</div>}
      <button className="primary-btn wide" disabled={busy} data-testid="reset-submit">{busy ? "Updating…" : "Update password"} <ChevronRight size={17} /></button>
    </form>}
  </div></section></main>;
}
